import React from 'react'
import cx from 'classnames'

import { Logo } from 'components/shared/Logo/Logo'
import { Navigation } from './common/Navigation/Navigation'
import { NavigationItem } from './common/NavigationItem/NavigationItem'
import { ToggleButton } from './common/ToggleButton/ToggleButton'

import styles from './Sidebar.module.scss'

export const Sidebar = ({ children, className = undefined, isCollapsed }) => (
  <aside
    className={cx(styles.aside, {
      [styles.collapsed]: isCollapsed,
      [className]: Boolean(className),
    })}
  >
    {children}
  </aside>
)

Sidebar.Logo = Logo
Sidebar.Navigation = Navigation
Sidebar.NavigationItem = NavigationItem
Sidebar.ToggleButton = ToggleButton
